import InvoiceItem from './invoice-item';

export default InvoiceItem;